<template>
  <div class="home">
    <!-- ===== Hero ===== -->
    <section class="hero">
      <div class="hero-bg-orb orb-a"></div>
      <div class="hero-bg-orb orb-b"></div>
      <div class="container hero-inner">
        <div class="hero-copy" v-reveal>
          <span class="eyebrow on-dark">DINGTONG WORK PHONE · 企业工作手机 + ERP</span>
          <h1>
            管人、管经营，
            <br />一部工作手机就够了
          </h1>
          <p class="hero-lead">
            叮通工作手机为企业统一配发，考勤审批、员工定位、轨迹回放与沟通留痕
            <b class="hero-hl">购机即用</b
            >；叮通ERP系统更内置于手机应用，单独开通权限即可升级企业经营数字化。
          </p>
          <div class="hero-actions">
            <router-link to="/product#work-phone" class="btn btn-accent">
              了解叮通工作手机
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </router-link>
            <router-link to="/product#erp" class="btn btn-ghost">
              了解 ERP 系统
            </router-link>
          </div>
          <p class="hero-note">
            咨询热线：
            <a href="tel:13906000035">139 0600 0035</a>
            &middot; 办公地址：厦门市集美区杏林北二路146号501室之二
          </p>
        </div>

        <div class="hero-visual" v-reveal>
          <div class="phone">
            <div class="phone-bar"></div>
            <div class="phone-head">
              <span class="ph-dot"></span>
              <strong>叮通 · 工作手机</strong>
              <span class="ph-bell"></span>
            </div>
            <div class="phone-greet">
              张工，早上好
              <br />
              <small>08:58 已打卡 · 今日外勤中</small>
            </div>
            <div class="stat-row">
              <div class="stat-box">
                <b>在线</b>
                <span>定位已开启</span>
              </div>
              <div class="stat-box">
                <b>3.6km</b>
                <span>今日轨迹</span>
              </div>
              <div class="stat-box">
                <b>3</b>
                <span>待办审批</span>
              </div>
            </div>
            <ul class="phone-list">
              <li>
                <i class="li-ico ok"></i>
                <div>
                  <strong>考勤审批</strong>
                  <p>08:58 定位打卡成功 · 出勤正常</p>
                </div>
              </li>
              <li>
                <i class="li-ico clock"></i>
                <div>
                  <strong>轨迹回放</strong>
                  <p>今日行程 3.6 km · 已云端记录</p>
                </div>
              </li>
              <li>
                <i class="li-ico chat"></i>
                <div>
                  <strong>微信沟通留痕</strong>
                  <p>工作沟通记录已合规留存</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="float-chip chip-1">
            <i></i>员工实时定位
          </div>
          <div class="float-chip chip-2">
            <i></i>沟通记录留痕
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 信任条 ===== -->
    <section class="trust-band">
      <div class="container trust-grid">
        <div class="trust-item" v-reveal>
          <span class="t-ico">01</span>
          <div>
            <b>制造场景</b>
            <p>围绕车间与产线的业务痛点设计</p>
          </div>
        </div>
        <div class="trust-item" v-reveal>
          <span class="t-ico">02</span>
          <div>
            <b>云端协同</b>
            <p>数据上云，手机电脑多端同步</p>
          </div>
        </div>
        <div class="trust-item" v-reveal>
          <span class="t-ico">03</span>
          <div>
            <b>开箱即用</b>
            <p>应用市场下载即可开始使用</p>
          </div>
        </div>
        <div class="trust-item" v-reveal>
          <span class="t-ico">04</span>
          <div>
            <b>持续迭代</b>
            <p>以客户反馈驱动产品快速更新</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 产品总览 ===== -->
    <section class="sec product-overview">
      <div class="container">
        <div class="section-head" v-reveal>
          <span class="eyebrow">PRODUCT OVERVIEW</span>
          <h2>叮通工作手机 + 叮通ERP —— 软硬一体管理方案</h2>
          <p class="lead">基础员工管理购机即用，企业经营管理单独开通 ERP 授权，一部手机按需升级。</p>
        </div>

        <div class="overview-grid">
          <div
            class="overview-card card card-hover"
            v-for="(f, i) in features"
            :key="f.title"
            v-reveal
            :style="{ transitionDelay: (i % 3) * 70 + 'ms' }"
          >
            <div class="ov-icon" v-html="f.icon"></div>
            <h3>{{ f.title }}</h3>
            <p>{{ f.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 为什么选择 ===== -->
    <section class="sec why-sec">
      <div class="why-bg why-glow-a"></div>
      <div class="why-bg why-glow-b"></div>
      <div class="container">
        <div class="section-head" v-reveal>
          <span class="eyebrow on-dark">WHY DINGTONG</span>
          <h2 class="light-title">为什么选择叮通</h2>
          <p class="light-lead">我们相信，制造企业的数字化不是把流程变复杂，而是让每一件日常小事都更顺手。</p>
        </div>

        <div class="why-grid">
          <article
            class="why-item card card-hover"
            v-for="(w, i) in whys"
            :key="w.title"
            v-reveal
            :style="{ transitionDelay: i * 80 + 'ms' }"
          >
            <div class="why-ico" v-html="w.icon"></div>
            <h3>{{ w.title }}</h3>
            <p>{{ w.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== 应用场景 ===== -->
    <section class="sec scenario-sec">
      <div class="container">
        <div class="section-head" v-reveal>
          <span class="eyebrow">SCENARIOS</span>
          <h2>典型应用场景</h2>
          <p class="lead">从外勤拜访到企业经营，叮通工作手机与 ERP 覆盖高频管理场景。</p>
        </div>

        <div class="scenario-grid">
          <div
            class="scenario-card card card-hover"
            v-for="(s, i) in scenarios"
            :key="s.title"
            v-reveal
            :style="{ transitionDelay: (i % 3) * 80 + 'ms' }"
          >
            <div class="sc-num">{{ String(i + 1).padStart(2, "0") }}</div>
            <h3>{{ s.title }}</h3>
            <p>{{ s.desc }}</p>
            <ul>
              <li v-for="tag in s.tags" :key="tag">{{ tag }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 方案咨询 CTA ===== -->
    <section class="download-cta">
      <div class="download-glow glow-a"></div>
      <div class="download-glow glow-b"></div>
      <div class="container download-inner" v-reveal>
        <div class="dl-copy">
          <span class="eyebrow on-dark">GET STARTED</span>
          <h2>需要工作手机，还是 ERP 方案？</h2>
          <p>
            购机即含考勤审批、员工定位、轨迹回放与沟通留痕等基础功能；
            <br />企业经营管理需要，单独开通「叮通ERP系统」即可在同一部手机上使用。
          </p>
          <div class="dl-btns">
            <a class="btn btn-accent" href="tel:13906000035">139 0600 0035</a>
            <router-link class="btn btn-ghost" to="/product#work-phone">查看产品方案</router-link>
          </div>
          <p class="dl-tip">
            支持样机体验与方案演示 ·
            <a href="tel:05928122001">座机 0592-8122001</a>
          </p>
        </div>

        <div class="dl-card">
          <div class="dl-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="5" y="2" width="14" height="20" rx="2.4" />
              <path d="M9 18.5h6M12 6v4.5M9.6 8.6 12 11l2.4-2.4" />
            </svg>
          </div>
          <h3>叮通</h3>
          <p>工作手机 · ERP 软硬一体方案</p>
          <div class="store-chips">
            <span>购机即用</span>
            <span>ERP单独授权</span>
          </div>
          <router-link to="/contact" class="btn btn-light btn-sm">联系商务咨询</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const icons = {
  chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" /></svg>',
  clock:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>',
  flow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h16M4 5v14M4 12h16" /><path d="M8 9.5 11 12l-3 2.5M16 9.5 13 12l3 2.5" /></svg>',
  iot: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M4 7a2 2 0 1 1-2 2M4 7a2 2 0 1 0-2 2M20 7a2 2 0 1 1 2 2M20 7a2 2 0 1 0 2 2" /><path d="M9 7a3 3 0 0 1 6 0M7 11a5 5 0 0 1 10 0M12 12l1.5 4h-3z" /><path d="M8 21v-5h8v5M10 16v3M14 16v3" /></svg>',
  pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></svg>',
  path: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="19" r="2.4" /><circle cx="18" cy="5" r="2.4" /><path d="M6 16.5c0-3 2.5-5.5 5.5-5.5h3" /><path d="M12 11c1.5-2 3.5-3.5 6-3.5" /></svg>',
  task: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>',
  report:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18" /><path d="M7 15l4-5 3 3 5-7" /></svg>',
  shield:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>',
  mobile:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2.5" width="12" height="19" rx="2.5" /><path d="M10 6h4M11 18.5h2" /></svg>',
  plug: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2v6M15 2v6M7 8h10v3a5 5 0 0 1-10 0zM12 16v6" /></svg>',
  team: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.4" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 5.2a3.4 3.4 0 0 1 0 5.6M21.5 20a6.5 6.5 0 0 0-4-6" /></svg>',
};

export default {
  name: "HomeView",
  data() {
    return {
      features: [
        {
          icon: icons.clock,
          title: "OA 考勤审批",
          desc: "工作手机定位打卡、外勤签到与请假出差审批购机即用，出勤数据自动沉淀、随时可查。",
        },
        {
          icon: icons.pin,
          title: "员工定位",
          desc: "在授权范围内实时掌握外勤与在岗员工位置，外勤管理更有依据，记录云端留存。",
        },
        {
          icon: icons.path,
          title: "轨迹回放",
          desc: "按时间维度回放员工行程轨迹，复盘外勤线路与拜访过程，管理动作清晰留痕。",
        },
        {
          icon: icons.chat,
          title: "沟通留痕",
          desc: "在法律法规与企业制度授权的范围内，留存微信等沟通记录，防止私单与飞单。",
        },
        {
          icon: icons.task,
          title: "ERP 经营管理",
          desc: "采购、销售、库存、生产与财务模块内置于手机应用，单独开通权限即可使用。",
        },
        {
          icon: icons.report,
          title: "经营报表",
          desc: "考勤、进销存与资金数据自动汇总，多维度看板帮助管理者快速掌握企业经营状况。",
        },
      ],
      whys: [
        {
          icon: icons.mobile,
          title: "软硬一体",
          desc: "工作手机与软件统一交付、统一管理，基础功能购机即含，省去多套软件采购与维护的麻烦。",
        },
        {
          icon: icons.shield,
          title: "合规留痕",
          desc: "在法律法规与企业制度授权范围内记录沟通与行为过程，保护客户资源与业务数据。",
        },
        {
          icon: icons.team,
          title: "按需升级",
          desc: "从员工管理起步，需要时单独开通 ERP 授权即可升级企业经营数字化，按需组合不浪费。",
        },
        {
          icon: icons.iot,
          title: "贴心服务",
          desc: "从样机体验到开通配置提供陪伴式服务，认真倾听一线反馈，让方案真正用起来、用得好。",
        },
      ],
      scenarios: [
        {
          title: "外勤与销售管理",
          desc: "外勤人员实时定位、轨迹回放，工作沟通留痕可查，有效防范私单飞单，保护客户资源。",
          tags: ["实时定位", "轨迹回放", "沟通留痕"],
        },
        {
          title: "考勤与流程办公",
          desc: "员工手机定位打卡、主管移动审批，考勤与流程数据自动汇总，节省大量统计时间。",
          tags: ["定位打卡", "移动审批", "考勤报表"],
        },
        {
          title: "企业经营数字化",
          desc: "开通 ERP 权限后，采购、销售、库存与财务在同一部手机上协同，经营数据随手掌握。",
          tags: ["进销存管理", "生产管理", "财务对账"],
        },
        {
          title: "多门店统筹管理",
          desc: "总部为各门店统一配发工作手机，人员与业务集中管理，分级授权、数据看板统一呈现。",
          tags: ["统一配发", "分级权限", "数据看板"],
        },
      ],
    };
  },
};
</script>

<style scoped>
/* ===== Hero ===== */
.hero {
  position: relative;
  padding: calc(var(--header-h) + 66px) 0 84px;
  color: #fff;
  background: radial-gradient(
      900px 480px at 8% -8%,
      rgba(37, 128, 255, 0.5),
      transparent 62%
    ),
    radial-gradient(
      720px 460px at 96% 4%,
      rgba(18, 194, 242, 0.3),
      transparent 55%
    ),
    linear-gradient(140deg, #071a44 0%, #0a2f8a 62%, #0f43ad 100%);
  overflow: hidden;
}
.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 46px 46px;
  pointer-events: none;
}
.hero-bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(10px);
  pointer-events: none;
}
.orb-a {
  width: 360px;
  height: 360px;
  left: -120px;
  bottom: -140px;
  background: radial-gradient(
    circle,
    rgba(18, 194, 242, 0.35),
    transparent 70%
  );
}
.orb-b {
  width: 260px;
  height: 260px;
  right: -60px;
  top: -80px;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.16),
    transparent 70%
  );
}
.hero-inner {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1.06fr 0.94fr;
  gap: 48px;
  align-items: center;
}
.hero-copy .eyebrow.on-dark {
  color: #4fd2ff;
}
.hero-copy h1 {
  color: #fff;
  font-size: clamp(30px, 4.4vw, 48px);
  letter-spacing: 0.01em;
  margin-bottom: 20px;
}
.hero-lead {
  color: rgba(255, 255, 255, 0.84);
  font-size: 17px;
  max-width: 560px;
  margin-bottom: 30px;
}
.hero-hl {
  color: #4fd2ff;
  font-weight: 700;
}
.hero-actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}
.hero-note {
  margin-top: 22px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.62);
}
.hero-note a {
  color: #6fd4ff;
}

/* hero phone */
.hero-visual {
  position: relative;
  justify-self: center;
  width: 100%;
  max-width: 380px;
}
.phone {
  position: relative;
  z-index: 2;
  margin: 0 auto;
  width: min(300px, 86%);
  background: #fff;
  border-radius: 34px;
  padding: 12px 12px 20px;
  box-shadow: 0 40px 90px rgba(3, 15, 51, 0.5);
  color: var(--c-ink);
  font-size: 13px;
}
.phone-bar {
  height: 5px;
  width: 34%;
  margin: 0 auto 8px;
  background: #d8e2f5;
  border-radius: 3px;
}
.phone-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px 12px;
  border-bottom: 1px solid #f0f3fb;
}
.phone-head strong {
  font-size: 15px;
}
.ph-dot,
.ph-bell {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #12c2f2, #1453e6);
}
.phone-greet {
  padding: 14px 8px 4px;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
}
.phone-greet small {
  display: block;
  font-weight: 400;
  color: var(--c-muted);
  font-size: 12px;
}
.stat-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 10px 6px;
}
.stat-box {
  background: #f3f7ff;
  border-radius: 12px;
  padding: 10px 4px;
  text-align: center;
}
.stat-box b {
  display: block;
  font-size: 17px;
  color: var(--c-primary);
}
.stat-box span {
  font-size: 11px;
  color: var(--c-muted);
}
.phone-list {
  padding: 4px 8px 0;
}
.phone-list li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 10px 4px;
  border-top: 1px solid #f0f3fb;
}
.phone-list li:first-child {
  border-top: none;
}
.li-ico {
  flex: none;
  width: 30px;
  height: 30px;
  margin-top: 1px;
  border-radius: 9px;
  position: relative;
  background: #eaf1ff;
}
.li-ico.chat::after {
  content: "";
  position: absolute;
  left: 8px;
  top: 9px;
  width: 14px;
  height: 11px;
  border: 2px solid #1453e6;
  border-radius: 4px;
  border-top: none;
}
.li-ico.ok::after {
  content: "";
  position: absolute;
  left: 8px;
  top: 7px;
  width: 12px;
  height: 7px;
  border-left: 2.4px solid #16b98a;
  border-bottom: 2.4px solid #16b98a;
  transform: rotate(-45deg);
}
.li-ico.clock::after {
  content: "";
  position: absolute;
  left: 9px;
  top: 9px;
  width: 11px;
  height: 11px;
  border: 2px solid #f0a020;
  border-radius: 50%;
}
.phone-list li strong {
  font-size: 13px;
  display: block;
}
.phone-list li p {
  margin: 2px 0 0;
  font-size: 11.5px;
  color: var(--c-muted);
  line-height: 1.5;
}
.float-chip {
  position: absolute;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: var(--c-ink);
  font-size: 12.5px;
  font-weight: 600;
  padding: 9px 15px;
  border-radius: 999px;
  box-shadow: 0 14px 34px rgba(3, 15, 51, 0.35);
  white-space: nowrap;
}
.float-chip i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #12c2f2;
  box-shadow: 0 0 0 4px rgba(18, 194, 242, 0.2);
}
.chip-1 {
  top: 16%;
  right: -6px;
}
.chip-2 {
  bottom: 14%;
  left: -10px;
}
.chip-2 i {
  background: #16b98a;
  box-shadow: 0 0 0 4px rgba(22, 185, 138, 0.2);
}

/* ===== 信任条 ===== */
.trust-band {
  background: #f4f8ff;
  border-bottom: 1px solid var(--c-line);
}
.trust-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.trust-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px 16px;
}
.trust-item + .trust-item {
  border-left: 1px solid var(--c-line);
}
.t-ico {
  font-size: 15px;
  font-weight: 800;
  color: var(--c-primary);
  background: #e6efff;
  border-radius: 10px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}
.trust-item b {
  display: block;
  color: var(--c-ink);
  font-size: 15px;
}
.trust-item p {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--c-muted);
}

/* ===== 产品总览 ===== */
.product-overview {
  background: #fff;
}
.overview-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.overview-card {
  padding: 30px 26px;
}
.ov-icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  margin-bottom: 18px;
  color: var(--c-primary);
  background: linear-gradient(135deg, #e8f1ff, #f2f8ff);
}
.ov-icon :deep(svg) {
  width: 28px;
  height: 28px;
}
.overview-card h3 {
  font-size: 18px;
}
.overview-card p {
  font-size: 14px;
  color: var(--c-muted);
  margin: 0;
  line-height: 1.8;
}

/* ===== 为什么选择 ===== */
.why-sec {
  position: relative;
  overflow: hidden;
  background: linear-gradient(140deg, #081a42 0%, #0a2f8a 60%, #10449f 100%);
}
.why-sec::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 46px 46px;
  pointer-events: none;
}
.why-sec .container {
  position: relative;
  z-index: 2;
}
.why-bg {
  position: absolute;
  border-radius: 50%;
  filter: blur(12px);
  pointer-events: none;
}
.why-glow-a {
  width: 420px;
  height: 420px;
  left: -150px;
  top: -180px;
  background: radial-gradient(
    circle,
    rgba(18, 194, 242, 0.32),
    transparent 70%
  );
}
.why-glow-b {
  width: 380px;
  height: 380px;
  right: -140px;
  bottom: -200px;
  background: radial-gradient(
    circle,
    rgba(27, 108, 255, 0.42),
    transparent 70%
  );
}
.why-sec .section-head {
  position: relative;
}
.why-sec h2.light-title {
  color: #fff;
}
.why-sec .light-lead {
  color: rgba(255, 255, 255, 0.72);
}
.why-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
  position: relative;
}
.why-item {
  padding: 28px 22px;
}
.why-ico {
  width: 50px;
  height: 50px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: #fff;
  background: linear-gradient(135deg, #1b6cff, #0a2f8a);
  box-shadow: 0 10px 22px rgba(20, 83, 230, 0.28);
}
.why-ico :deep(svg) {
  width: 26px;
  height: 26px;
}
.why-item h3 {
  font-size: 17px;
}
.why-item p {
  font-size: 13.5px;
  color: var(--c-muted);
  margin: 0;
  line-height: 1.85;
}

/* ===== 应用场景 ===== */
.scenario-sec {
  background: #fff;
}
.scenario-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
}
.scenario-card {
  padding: 28px 22px;
}
.sc-num {
  font-size: 34px;
  font-weight: 800;
  line-height: 1;
  background: linear-gradient(135deg, #12c2f2, #1453e6);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  opacity: 0.85;
  margin-bottom: 16px;
}
.scenario-card h3 {
  font-size: 17px;
  margin-bottom: 10px;
}
.scenario-card p {
  font-size: 13.5px;
  color: var(--c-muted);
  line-height: 1.85;
  margin-bottom: 14px;
}
.scenario-card ul {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.scenario-card ul li {
  font-size: 12px;
  color: var(--c-primary);
  background: #edf3ff;
  padding: 4px 10px;
  border-radius: 999px;
}

/* ===== 下载 CTA ===== */
.download-cta {
  position: relative;
  overflow: hidden;
  color: #fff;
  background: linear-gradient(135deg, #071a44, #0a2f8a 55%, #12419f);
  padding: 92px 0;
}
.download-cta::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.045) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.045) 1px, transparent 1px);
  background-size: 46px 46px;
  pointer-events: none;
}
.download-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(12px);
}
.glow-a {
  width: 420px;
  height: 420px;
  left: -140px;
  top: -160px;
  background: radial-gradient(
    circle,
    rgba(18, 194, 242, 0.35),
    transparent 70%
  );
}
.glow-b {
  width: 360px;
  height: 360px;
  right: -120px;
  bottom: -180px;
  background: radial-gradient(circle, rgba(27, 108, 255, 0.4), transparent 70%);
}
.download-inner {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 56px;
  align-items: center;
}
.dl-copy .eyebrow.on-dark {
  color: #4fd2ff;
}
.dl-copy h2 {
  color: #fff;
  font-size: clamp(26px, 3.4vw, 38px);
  margin-bottom: 16px;
}
.dl-copy p {
  color: rgba(255, 255, 255, 0.82);
  font-size: 15.5px;
  line-height: 1.9;
}
.dl-btns {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin: 24px 0 8px;
}
.dl-tip {
  font-size: 13px !important;
  color: rgba(255, 255, 255, 0.6) !important;
}
.dl-tip a {
  color: #6fd4ff;
}
.dl-card {
  position: relative;
  justify-self: center;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 26px;
  padding: 34px 30px;
  text-align: center;
  width: min(300px, 100%);
  backdrop-filter: blur(6px);
}
.dl-icon {
  width: 74px;
  height: 74px;
  margin: 0 auto 14px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #1b6cff, #12c2f2);
  box-shadow: 0 14px 34px rgba(18, 194, 242, 0.35);
}
.dl-icon svg {
  width: 36px;
  height: 36px;
}
.dl-card h3 {
  color: #fff;
  font-size: 24px;
  letter-spacing: 0.12em;
  margin-bottom: 4px;
}
.dl-card p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  margin-bottom: 16px;
}
.store-chips {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 20px;
}
.store-chips span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 4px 12px;
  border-radius: 999px;
}

@media (max-width: 992px) {
  .hero-inner {
    grid-template-columns: 1fr;
    gap: 52px;
  }
  .hero-copy h1 br {
    display: none;
  }
  .overview-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .why-grid,
  .scenario-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .download-inner {
    grid-template-columns: 1fr;
  }
  .dl-card {
    display: none;
  }
}
@media (max-width: 640px) {
  .trust-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .trust-item + .trust-item {
    border-left: none;
  }
  .overview-grid,
  .why-grid,
  .scenario-grid {
    grid-template-columns: 1fr;
  }
  .hero-visual {
    max-width: 320px;
  }
}
</style>
